import { useState, useEffect } from "react";
import ListTable from "../ListTable";
import ColleaguesListsStore from "../../../../stores/lists/ColleagueListStore";
import Accordion, { AccordionContent, AccordionTrigger } from "@reactComponents/lds/accordion/Accordion";
import Heading from "@reactComponents/lds/typography/Heading";
import Chip from "@reactComponents/lds/chips/Chip";
import Table from "@reactComponents/lds/table/Table";
import Header from "@reactComponents/lds/table/Header";
import Row from "@reactComponents/lds/table/Row";
import Cell from "@reactComponents/lds/table/Cell";
import Spacer from "@reactComponents/lds/Spacer";


/** An expansion panel that grows to show a table */
export default function ColleaguesListRow({ lists, evenChild }) {
  const [open, setOpen] = useState(false);
  const { name, id } = lists[0].user;
  const panelStyle = {
    backgroundColor: evenChild ? "var(--color-gray-200)" : "white",
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('id') === id) {
      setOpen(true);
    }
  }, [id]);

  const trailingAction =
    <>
      <div className="flex-grow-1" />
      <Chip
        label=""
        selected={open}
        size="small"
        leadingIcon={`chevron-${open ? "up" : "down"}-centered`}
        variant={open ? "primary" : "secondary"}
      />
    </>;

  return (
    <Accordion open={open} className="stages-accordion colleagues-list-expansion-panel">
      <AccordionTrigger className="cursor-pointer" onClick={ () => setOpen(!open) }>
        <Table width="100%">
          <Header>
            <Row className="colleagues-list-header" header selected={open}>
              <Cell header className="colleague-title fullstory_excluded">
                {name} ({lists.length})
                <Spacer />
                { trailingAction }
              </Cell>
            </Row>
          </Header>
        </Table>
      </AccordionTrigger>
      <AccordionContent>
        <ExpansionPanelBody lists={lists} />
      </AccordionContent>
    </Accordion>
  );
}

function ExpansionPanelBody({ lists }) {
  return (
    <div className="colleagues-list-expansion-panel-body">
      <ListTable
        lists={lists}
        showTag={ColleaguesListsStore.data.selectedCategory === "All"}
        editable={false}
        showHeader={false}
        entriesAlignment={"end"}
      />
    </div>
  );
}
